import { GeneralModel } from "./general.model";
import { ListReceiptMoneyStatus } from "./listReceiptMoneyStatus.model";
import { ListReceiptMoneyType } from "./listReceiptMoneyType.model";
import { Hub } from "./hub.model";
import { User } from "./user.model";

export class ListReceiptMoney extends GeneralModel {
    fromHubId: number;
    toHubId: number;
    paidByEmpId: number;
    totalShipment: number;
    totalCOD: number;
    totalPrice: number;
    grandTotal: number;
    grandTotalReal: number;
    attachmentId: number;
    orderDate: Date;
    createdWhen: Date;
    listReceiptMoneyStatusId: number;
    listReceiptMoneyTypeId: number;
    listReceiptMoneyType: ListReceiptMoneyType;
    listReceiptMoneyStatus: ListReceiptMoneyStatus;
    fromHub: Hub;
    toHub: Hub;
    isTransfer: boolean;
    feeBank: number;
    userCreated: User;
}